import { useState, useEffect } from 'react';

import Util from '../util/util.js';

/**
 * useFeature - gate UI on a per-org feature toggle.
 *
 * Reads the enabled-feature list cached for the active organization (populated by
 * Util.setOrganizationSettings on login / org-switch). Returns true when `featureKey`
 * is enabled for the active org, false otherwise.
 *
 * @param {string} featureKey - the feature key (e.g. 'test-feature')
 * @returns {boolean}
 */
export default function useFeature(featureKey) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    Util.isFeatureEnabled(featureKey).then((value) => {
      if (active) setEnabled(value);
    });
    return () => {
      active = false;
    };
  }, [featureKey]);

  return enabled;
}
